var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.663,
    height: 14.684,
    viewBox: "0 0 17.663 14.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-store",
    "data-name": "Icon awesome-store",
    d: "M17.266,3.4,15.4.43A.918.918,0,0,0,14.628,0H3.042a.918.918,0,0,0-.777.43L.4,3.4A2.558,2.558,0,0,0,2.09,7.313a2.98,2.98,0,0,0,.393.026A2.832,2.832,0,0,0,4.6,6.389a2.834,2.834,0,0,0,4.233,0,2.834,2.834,0,0,0,4.233,0,2.841,2.841,0,0,0,2.116.949,2.948,2.948,0,0,0,.393-.026A2.556,2.556,0,0,0,17.266,3.4ZM15.187,8.259a3.639,3.639,0,0,1-.846-.109v2.862H3.329V8.15a3.8,3.8,0,0,1-.846.109,3.869,3.869,0,0,1-.516-.034,3.606,3.606,0,0,1-.47-.1v5.644a.917.917,0,0,0,.918.918H15.261a.917.917,0,0,0,.918-.918V8.121a2.928,2.928,0,0,1-.47.1A3.988,3.988,0,0,1,15.187,8.259Z",
    transform: "translate(-0.004)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.ad006796.svg";
export { ForwardRef as ReactComponent };